module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/confirm-de89cb25906c606278da71708f732f2a.png";